/* eslint-disable */
// ResetLanding — scanner-proof interstitial for password recovery (Phase C).
// The recovery email links to {{ .SiteURL }}/?reset_token_hash={{ .TokenHash }} —
// loading THIS page consumes nothing, so corporate mail scanners that GET the
// link can no longer burn the single-use token (the 2026-07-07 "invalid or has
// expired" incidents). Only the explicit Continue click calls verifyOtp, which
// creates the session; App.js then routes to SetPasswordScreen (strength meter).
// Reuses the shared .loginRoot DNA chrome (same module as SetPasswordScreen).
// The legacy PASSWORD_RECOVERY event path in App.js stays untouched as fallback.
import React, { useState } from "react";
import { supabase } from "../../supabase";
import styles from "../EntryLoginScreen.module.css";

export function ResetLanding({ tokenHash, onVerified, onCancel }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const handleContinue = async () => {
    setBusy(true); setError("");
    const { error: err } = await supabase.auth.verifyOtp({ type: "recovery", token_hash: tokenHash });
    if (err) {
      setBusy(false);
      setError(
        /expired|invalid/i.test(err.message || "")
          ? "This reset link has expired or was already used. Go back to sign in and request a new one."
          : err.message
      );
      return;
    }
    // Session established — clean the token from the URL, hand off to App.js.
    window.history.replaceState({}, "", window.location.pathname);
    onVerified();
  };

  const handleBack = () => {
    window.history.replaceState({}, "", window.location.pathname);
    onCancel();
  };

  return (
    <div className={styles.loginRoot}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <span className={styles.brandLogo} aria-label="Carolina Lemke Berlin">
            <span className={styles.brandTop}>Carolina Lemke</span>
            <span className={styles.brandBottom}>Berlin</span>
          </span>
        </div>
        <div className={styles.brandDivider} aria-hidden="true"></div>
        <div className={styles.brandLine3}>Operations Hub</div>
        <div className={styles.separator}></div>

        <div className={styles.welcome}>
          <h1 className={styles.welcomeTitle}>Reset your password</h1>
          <p className={styles.welcomeSub}>
            {error ? "Something went wrong with this link" : "Click below to continue — this step keeps your one-time link safe"}
          </p>
        </div>

        {error && <div className={styles.fieldError} role="alert">{error}</div>}

        <div className={styles.form}>
          {!error && (
            <button
              type="button"
              className={`${styles.submit} ${busy ? styles.submitLoading : ""}`}
              onClick={handleContinue}
              disabled={busy}
            >
              <span>{busy ? "Verifying…" : "Continue to set password"}</span>
            </button>
          )}
          <button
            type="button"
            className={styles.fieldAction}
            style={{ marginTop: 14, width: "100%", textAlign: "center" }}
            onClick={handleBack}
          >
            ← Back to sign in
          </button>
        </div>
      </div>

      <div className={styles.footer}>
        © 2026 Carolina Lemke Berlin · Operations Hub v2.0 · Secure connection
      </div>
    </div>
  );
}
